import { Component } from "react";


const title = "Our Mission";
const desc =
  "Our mission is to empower gamers worldwide by creating fair competition, real opportunities, and a path to the professional esports scene.";



class Mission extends Component {
  render() {
    return (
      <section
        className="mission-section"
        style={{
          backgroundImage: "url('/assets/images/about/about-2.jpg')",
        }}
      >
        <div className="container">
          <div className="section-wrapper padding-top">
            <div className="row">

              {/* CONTENT LEFT */}
              <div className="col-lg-6 col-md-10">
                <div className="mission-wrapper">
                  <div className="section-header">


                    <h2 className="text-anim-typing js-animate delay-md">
                      {title}
                    </h2>
                  </div>

                  <div className="mission-content text-anim-fade-down js-animate delay-md">
                    <p>{desc}</p>

                    <ul className="mission-list">

                    </ul>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Mission;
